import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef,
} from '@angular/core';
import { RouterLink } from '@angular/router';

import { I18nService, TranslatePipe } from '@recruitee/i18n';

import {
  ConnectedOverlayDirective,
  OverlayOriginDirective,
} from '../../core/overlay/overlay-directives';
import { DialogService } from '../../dialogs/dialogs.service';
import { BadgeComponent } from '../badge/badge.component';
import { ButtonComponent } from '../button/components/button/button.component';
import { ButtonLoadingDirective } from '../button/directives/button-loading/button-loading.directive';
import { DropdownItemComponent } from '../dropdown/dropdown-item/dropdown-item.component';
import { DropdownComponent, DropdownWidth } from '../dropdown/dropdown.component';
import { GroupComponent } from '../group/group.component';
import { HeadingComponent } from '../heading/heading.component';
import { IconColorDirective } from '../icon/directives/icon-color.directive';
import { IconComponent } from '../icon/icon.component';
import { RtTooltip } from '../tooltip/tooltip.directive';

@Component({
  selector: 'rt-integration-item',
  templateUrl: './integration-item.component.html',
  styleUrls: ['./integration-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BadgeComponent,
    ButtonComponent,
    ButtonLoadingDirective,
    ConnectedOverlayDirective,
    DropdownComponent,
    DropdownItemComponent,
    GroupComponent,
    HeadingComponent,
    IconColorDirective,
    IconComponent,
    OverlayOriginDirective,
    RouterLink,
    RtTooltip,
    TranslatePipe,
  ],
})
export class IntegrationItemComponent {
  @Input() public heading: string;
  @Input() public isIntegrationLoaded: boolean = false;
  @Input() public hasIntegration: boolean = false;
  @Input() public hasRole: boolean = false;
  @Input() public isRemoving: boolean = false;
  @Input() public isComingSoon: boolean = false;
  @Input() public teamIntegrationsCount: number = 0;
  @Input() public hasRemove: boolean = true;

  @Output() public integrate: EventEmitter<void> = new EventEmitter();
  @Output() public remove: EventEmitter<void> = new EventEmitter();

  public DropdownWidth = DropdownWidth;
  public dropdownOpen = false;

  constructor(
    private dialogService: DialogService,
    private viewContainerRef: ViewContainerRef,
    private i18n: I18nService,
    protected cdRef: ChangeDetectorRef,
  ) {}

  public toggleDropdown(open: boolean): void {
    this.dropdownOpen = open;
    this.cdRef.detectChanges();
  }

  public confirmRemove(): void {
    this.toggleDropdown(false);

    const options = {
      title: this.i18n.translate('app.settings.integrations.disconnect_confirm_title', {
        name: this.heading,
      }),
      message: this.i18n.translate('app.settings.integrations.disconnect_confirm_message', {
        name: this.heading,
      }),
      variant: 'warning',
      isCancelable: true,
    };

    this.dialogService.confirm(options, this.viewContainerRef).subscribe(data => {
      if (data) {
        this.remove.emit();
      }
    });
  }
}
